(function () {
  'use strict';

  function swap(label, next) {
    label.classList.add('sc-byob-out');
    window.setTimeout(function () {
      label.textContent = next;
      label.classList.add('sc-byob-prep');
      label.classList.remove('sc-byob-out');
      void label.offsetWidth;
      label.classList.remove('sc-byob-prep');
    }, 300);
  }

  function init(pill) {
    if (pill.__scbInit) return;
    pill.__scbInit = true;
    var label = pill.querySelector('[data-sc-byob-label]');
    if (!label) return;
    var a = pill.getAttribute('data-sc-byob-a') || label.textContent;
    var b = pill.getAttribute('data-sc-byob-b') || '';
    if (!b) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var dur = (parseFloat(pill.getAttribute('data-sc-byob-dur')) || 6) * 1000;
    var showingA = true;
    setInterval(function () {
      showingA = !showingA;
      swap(label, showingA ? a : b);
    }, dur / 2);
  }

  function all(scope) {
    (scope || document).querySelectorAll('.sc-byob__pill[data-sc-byob-b]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
}());